const DEFAULT_FORM_DATA = {
  property: {
    isSecuredPropertySameAsApplicantAddress: undefined,
    address: "",
    buildingName: "",
    buildingNumber: "",
    subBuildingName: "",
    subBuildingNumber: "",
    thoroughfare: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    townOrCity: "",
    county: "",
    postcode: "",
    propertyType: "",
    propertyStyle: "",
    groundRentIfFlat: "",
    noOfBedrooms: undefined,
  },
};

export default DEFAULT_FORM_DATA;
